/* eslint-disable */

import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";

import { httpsCallable } from "firebase/functions";

import { db, functions } from "../firebase";

export async function getSchoolSetupStatus(schoolId) {
  if (!schoolId) throw new Error("schoolId is required.");

  const ref = doc(db, "schools", schoolId, "setup", "status");
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    return {
      profileCompleted: false,
      brandingCompleted: false,
      staffCompleted: false,
      classesCompleted: false,
      parentsCompleted: false,
      setupCompleted: false,
    };
  }

  return snap.data();
}

export async function updateSchoolSetupStatus(schoolId, updates) {
  if (!schoolId) throw new Error("schoolId is required.");

  const ref = doc(db, "schools", schoolId, "setup", "status");

  await setDoc(
    ref,
    {
      ...updates,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

  return true;
}

/* =========================================================
   PROFILE SETUP
========================================================= */

export async function saveSchoolProfileSetup(payload) {
  const callable = httpsCallable(
    functions,
    "saveSchoolProfileSetup"
  );

  const res = await callable(payload || {});
  return res.data;
}

/* =========================================================
   BRANDING SETUP
========================================================= */

export async function saveSchoolBrandingSetup(payload) {
  const callable = httpsCallable(
    functions,
    "saveSchoolBrandingSetup"
  );

  const res = await callable(payload || {});
  return res.data;
}